<template>
  <div :class="{ popIn: visible }" :style="style" class="dialog-card icon-img_card_entry_bg" v-show="visible">
    <div v-show="$slots.countryMsg" class="country-tip">
      <slot name="countryMsg" />
    </div>
    <i v-if="showClose" class="icomoon-common_clos" @click="closeDialog" />
    <div class="header">
      <span v-if="title" :title="title">{{ title }}</span>
      <slot v-if="!title" name="header" />
    </div>
    <div class="context">
      <slot />
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'DialogCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    // 自动等比缩放
    autoScale: {
      type: Boolean,
      default: false
    },
    isAdaptation: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      style: ''
    };
  },
  created() {
    if (this.isAdaptation) {
      this.scaleDialogSize();
      window.addEventListener('resize', this.scaleDialogSize);
    }
  },
  beforeDestroy() {
    if (this.isAdaptation) {
      window.removeEventListener('resize', this.scaleDialogSize);
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false);
      this.$emit('on-close');
    },
    scaleDialogSize() {
      let power = 1;
      // 小于1000 不继续缩放
      if (document.body.clientWidth < 1000) {
        return;
      }
      // 防止等比缩放过小
      if (!this.autoScale && document.body.clientWidth < 1600) {
        power = 1.3;
      }
      this.style = {
        transform: `scale(${(document.body.clientWidth / 1920) * power}) translate(-50%, -50%) `,
        transformOrigin: 'left top'
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/Common/styles/var.scss';
.dialog-card {
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*width: 560px;*/
  max-width: 560px;
  // max-height: 560px;
  border-radius: 56px;
  background-color: #fff;
  background-position: 50% 25%;
  z-index: 1999;
  /*padding-top: 57px;*/
  overflow: hidden;
  width: 85vh;
  min-height: 560px;
  /*@media (max-width: 1366px) {*/
  /*    width: 30%;*/
  /*    height: auto !important;*/
  /*    .footer {*/
  /*        max-height: 70px;*/
  /*    }*/
  /*}*/
  .country-tip {
    margin-top: 64px;
  }

  .icomoon-common_clos {
    position: absolute;
    right: 32px;
    top: 32px;
  }
  .header {
    padding: 57px 0 45px 80px;
    height: 45px;
    > span {
      font-size: 22px;
      color: rgba(0, 0, 0, 0.9);
      font-weight: 600;
    }
  }
  .context {
    padding: 0 80px 90px 80px;
    flex-grow: 1;
    > div {
      overflow: hidden;
    }
    /*height: 370px;*/
    /*overflow: hidden;*/
  }
  .footer {
    position: absolute;
    bottom: 0;
    height: 90px;
    background-color: rgba(0, 0, 0, 0.03);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.popIn {
  animation: popIn 0.5s alternate;
}
@-webkit-keyframes popIn {
  0% {
    transform: translate(-50%, -50%) scale3d(0.5, 0.5, 0.5);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
